export const COPY_CLIPBOARD_TOGGLE_TIMEOUT = 4000;
